import React, { useContext,useCallback } from 'react'
import { useSelector } from 'react-redux';




export const Importer = ({ renderForm }) => {
  const dataSource = useSelector((state) => state.Actor.importer)

  const boxNumber = {name:"3/15", eoriNo:"3/16"}
  return renderForm
    ? renderForm({
        actorType: 'importer',
       boxNumber:{boxNumber},
        dataSource: dataSource,
        actorName:"Importer Name"
      })
    : null
}